import { AxiosResponse } from 'axios';
import api from './api';

const getPlayerConfig = async (payload: Services.Player.GetConfig): Promise<AxiosResponse> => (
  api.get('player', { params: { ...payload } })
);

type UpdateConfig = Services.Player.UpdateConfig;
const updatePlayerConfig = async (payload: UpdateConfig): Promise<AxiosResponse> => (
  api.put('player', payload)
);

export default {
  getPlayerConfig,
  updatePlayerConfig,
};
